const config =  {
    appName: process.env.REACT_APP_APP_NAME,
    apiURL: process.env.REACT_APP_API_URL,
    tokenKey: process.env.REACT_APP_TOKEN_KEY,
    adminAppURL: process.env.REACT_APP_ADMIN_APP_URL,
}

export default config;